
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Shreepad Shreevallabh Tvam Sadaiv" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Shreepad Shreevallabh Tvam Sadaiv" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Ghorkashtodharan Stotram, dattamaharaj, Shreepad Shreevallabh Tvam Sadaiv, घोरात्कष्टादुद्धरास्मान्नमस्ते, Ghorkashtodharan Stotram marathi, Ghorkashtodharan Stotram english, swami stotra, घोरकष्टोधरणस्तोत्रम, shreepad shree vallabh stotra, श्रीपाद श्रीवल्लभ स्तोत्र'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shreepad Shreevallabh, Ghorkashtodharan Stotram, Devotional stotra, घोरात्कष्टादुद्धरास्मान्नमस्ते, Ghorkashtodharan prayer, घोरकष्टोद्धरण स्तोत्र मराठी, श्रीपाद श्रीवल्लभ त्वम् सदैव, Swami vasudevanand saraswati, घोरकष्टोधरणस्तोत्रम, swami stotra, datta stotra, shreepad shree vallabh stotra, श्रीपाद श्रीवल्लभ स्तोत्र' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/dattamaharaj.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/dattamaharaj.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Shreepad Shreevallabh Tvam Sadaiv | Ghorkashtodharan Stotram - श्रीपाद श्रीवल्लभ त्वम् सदैव(घोरकष्टोधरणस्तोत्रम)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/dattamaharaj"
        },
        "headline": "Shreepad Shreevallabh Tvam Sadaiv - श्रीपाद श्रीवल्लभ त्वम् सदैव(घोरकष्टोधरणस्तोत्रम)",
        "name" : "Shreepad Shreevallabh Tvam Sadaiv - Ghorkashtodharan Stotram",
        "description": "Explore the full lyrics of stotra 'Shreepad Shreevallabh Tvam Sadaiv' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/dattamaharaj.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  